import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=89064f8e&scoped=true&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"
import style0 from "./Flight.vue?vue&type=style&index=0&id=89064f8e&lang=less&scoped=true&"
import style1 from "./Flight.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89064f8e",
  null
  
)

component.options.__file = "Flight.vue"
export default component.exports